import { defineStyleConfig } from '@chakra-ui/react';

const Button = defineStyleConfig({
  // The styles all buttons have in common
  baseStyle: {
    fontWeight: 'semibold',
    borderRadius: 'full',
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    transition:
      'background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease, color 0.2s ease',
    _focusVisible: {
      boxShadow: 'outline',
      outline: '2px solid',
      outlineColor: 'blue.500',
      outlineOffset: '2px',
    },
  },
  sizes: {
    sm: { h: 9, minW: 9, px: 4, fontSize: 'sm' },
    md: { h: 12, minW: 12, px: 7, fontSize: 'md' },
    lg: { h: 14, minW: 14, px: 9, fontSize: 'lg' },
  },
  variants: {
    // Main blue CTA
    primary: {
      bg: 'blue.500',
      color: 'white',
      boxShadow: '0 10px 24px -8px rgba(41, 171, 226, 0.55)',
      _hover: {
        bg: 'blue.600',
        boxShadow: '0 14px 28px -8px rgba(41, 171, 226, 0.6)',
        transform: 'translateY(-1px)',
        _disabled: { bg: 'blue.500', transform: 'none' },
      },
      _active: { bg: 'blue.700', transform: 'translateY(0)', boxShadow: '0 6px 16px -8px rgba(41, 171, 226, 0.6)' },
    },
    // Amber CTA — logo accent, dark text for contrast
    amber: {
      bg: 'amber.500',
      color: 'brand.navy',
      boxShadow: '0 10px 24px -8px rgba(255, 183, 0, 0.5)',
      _hover: {
        bg: 'amber.600',
        boxShadow: '0 14px 28px -8px rgba(255, 183, 0, 0.55)',
        transform: 'translateY(-1px)',
      },
      _active: { bg: 'amber.700', transform: 'translateY(0)' },
    },
    // Blue outline
    outline: {
      bg: 'white',
      color: 'blue.600',
      border: '1.5px solid',
      borderColor: 'blue.500',
      _hover: { bg: 'blue.50', borderColor: 'blue.600', color: 'blue.700' },
      _active: { bg: 'blue.100' },
    },
    // Deep navy CTA — 产品页里的次级/深色动作（如「了解号码方案」）
    navy: {
      bg: 'brand.navy',
      color: 'white',
      boxShadow: '0 10px 24px -8px rgba(11, 61, 92, 0.45)',
      _hover: {
        bg: 'blue.900',
        boxShadow: '0 14px 28px -8px rgba(11, 61, 92, 0.5)',
        transform: 'translateY(-1px)',
      },
      _active: { bg: 'blue.900', transform: 'translateY(0)' },
    },
    // 深色卡片上的描边按钮（白字白边），用于海军蓝背景
    onDark: {
      bg: 'whiteAlpha.100',
      color: 'white',
      border: '1.5px solid',
      borderColor: 'whiteAlpha.500',
      _hover: { bg: 'whiteAlpha.300', borderColor: 'white' },
      _active: { bg: 'whiteAlpha.400' },
    },
    // Subtle ghost for icon/utility actions
    ghost: {
      bg: 'transparent',
      color: 'gray.700',
      _hover: { bg: 'blue.50', color: 'blue.600' },
      _active: { bg: 'blue.100' },
    },
    // Backward-compatible names
    solid: {
      bg: 'blue.500',
      color: 'white',
      boxShadow: '0 10px 24px -8px rgba(41, 171, 226, 0.55)',
      _hover: { bg: 'blue.600' },
      _active: {bg: 'blue.700'},
    },
    nav: {
      bg: 'transparent',
      _hover: { bg: 'blue.50', color: 'blue.600' },
      _active: { bg: 'blue.100' },
    },
  },
  // The default size and variant values
  defaultProps: {
    size: 'md',
    variant: 'primary',
  },
});

export default Button;
